export default {
  SET_CHANGES: () => {
    // console.log('Guardado el addon en redo-undo');
  }
}